@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteBlackImage {
  .image {
    width: 100%;
    position: relative;

    .screen {
      width: 100%;
      border-radius: 16px;
    }
  }


  @media screen and (max-width: 930px) {
  }
}